<div [ngClass]="isMobile ? 'container-titulo-rotina-mobile' : foraAppComponent ? 'container-titulo-rotina-fora-app-component' : 'container-titulo-rotina'">
  <div class="container-voltar">
    <button mat-flat-button [ngClass]="isMobile ? 'btn-voltar-mobile' : 'btn-voltar'" (click)="voltar()">
      <mat-icon style="margin: 0;">chevron_left</mat-icon>
    </button>
    <span class="weight-700 font-14">{{titulo}}</span>
  </div>

  @if (idRotina) {
    <button mat-flat-button class="btn-log" (click)="abrirModalLog()">
      <img src="./assets/icones/log.svg" alt="Visualizar logs" />
    </button>
  }
</div>
